import { render, staticRenderFns } from "./ColorPanel.vue?vue&type=template&id=3a363db7"
import script from "./ColorPanel.vue?vue&type=script&lang=js"
export * from "./ColorPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports